{
  "help_page": {
    "hero": {
      "title": "Help & Resource Center",
      "subtitle": "Find answers, download templates, and get support for your SOR Registry needs",
      "search_placeholder": "Search help articles, FAQs, and guides..."
    },
    "quick_access": {
      "faq": {
        "title": "FAQs",
        "description": "Find quick answers to common questions",
        "count": "150+ articles"
      },
      "templates": {
        "title": "Templates",
        "description": "Download required forms and documents",
        "count": "25+ templates"
      },
      "guides": {
        "title": "User Guides",
        "description": "Step-by-step instructions and tutorials",
        "count": "12 guides"
      },
      "support": {
        "title": "Support Ticket",
        "description": "Get personalized help from our team",
        "availability": "24/7 support"
      }
    },
    "faq_section": {
      "title": "Frequently Asked Questions",
      "developer": {
        "title": "Project Developers",
        "questions": {
          "registration": "How do I register as a Project Developer?",
          "registration_answer": "Complete the registration form with required documents and pay the $1,000 registration fee. You'll receive a Developer Identification Number (DIN) upon approval.",
          "pin_documents": "What documents are required for PIN submission?",
          "pdd_approval": "How long does PDD approval take?"
        }
      },
      "auditor": {
        "title": "Auditors (DOE)",
        "questions": {
          "doe_requirements": "What are the DOE registration requirements?",
          "doe_requirements_answer": "Provide accreditation body details, sectoral scope selection, risk management framework, and declaration of impartiality. Registration fee is $3,000.",
          "upload_reports": "How do I upload verification reports?",
          "conflict_policy": "What is the conflict of interest policy?"
        }
      },
      "trader": {
        "title": "Credit Holders",
        "questions": {
          "transfer_credits": "How do I transfer credits?",
          "transfer_credits_answer": "Use the Credit Transfer function in your dashboard. Provide recipient details and specify the number of credits to transfer.",
          "retirement_process": "What is the retirement process?",
          "view_ledger": "How do I view my credit ledger?"
        }
      }
    },
    "templates_section": {
      "title": "Download Templates",
      "project_documents": {
        "title": "Project Documents",
        "pin_template": "PIN Template",
        "pdd_template": "PDD Template",
        "npramp_form": "NPRAMP Form"
      },
      "monitoring": {
        "title": "Monitoring & Reporting",
        "rmr_template": "RMR Template",
        "sdr_template": "SDR Template",
        "reversal_form": "Reversal Event Form"
      },
      "compliance": {
        "title": "Compliance & Legal",
        "ehmf_template": "EHMF Template",
        "spcp_template": "SPCP Template",
        "fpic_form": "FPIC Form"
      }
    },
    "support_ticket": {
      "title": "Submit Support Ticket",
      "subtitle": "Can't find what you're looking for? Our support team is here to help.",
      "form": {
        "full_name": "Full Name",
        "email_address": "Email Address",
        "user_role": "User Role",
        "priority_level": "Priority Level",
        "subject": "Subject",
        "description": "Description",
        "description_placeholder": "Please describe your issue in detail...",
        "attachments": "Attachments",
        "upload_text": "Drag and drop files here or click to browse",
        "max_file_size": "Max file size: 10MB",
        "roles": {
          "project_developer": "Project Developer",
          "auditor_doe": "Auditor (DOE)",
          "credit_holder_trader": "Credit Holder/Trader",
          "government_dna": "Government/DNA",
          "other": "Other"
        },
        "priorities": {
          "low": "Low",
          "medium": "Medium",
          "high": "High",
          "urgent": "Urgent"
        }
      }
    }
  }
}